import { useContext as r } from "react";
import { ConfirmContext as o } from "../ConfirmDialogProvider.js";
const i = () => {
  const i2 = r(o);
  if (!i2) throw new Error("useConfirm must be used within ConfirmDialogProvider");
  return i2;
};
export {
  i as useConfirmContext
};
//# sourceMappingURL=useConfirmContext.js.map
